module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [_c('filters', {
    on: {
      "changeFilters": _vm.filtersChanged
    }
  }), _vm._v(" "), _c('more')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e28a84"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Events.vue
// module id = 2379
// module chunks = 0